<template>
  <div class="content">
    <!------搜索模块---->
    <el-form :model="searchData" ref="search">
      <QS-search>
        <el-form-item prop="plateNo" clearable label="车牌号">
          <el-input
            v-model="searchData.plateNo"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="customerName" clearable label="客户">
          <el-input
            v-model="searchData.customerName"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="createdDate" clearable label="关联创建时间">
          <el-date-picker
            v-model="searchData.createdDate"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            range-separator="至"
            end-placeholder="结束日期"
            prefix-icon="el-icon-date"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="所属部门" prop="deptIdList">
          <DeptSelect v-model="searchData.deptIdList" multiple :isAll="false" />
        </el-form-item>
        <el-form-item label="订单类型" prop="orderType">
          <el-select
            v-model="searchData.orderType"
            clearable
            placeholder="请选择订单类型"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in orderTypeList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <template slot="moreBtn">
          <el-form-item>
            <el-button
              :loading="oLoading.search"
              size="small"
              type="primary"
              @click="searchHandle"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="formResetFields('search')"
              >重置</el-button
            >
          </el-form-item>
        </template>
      </QS-search>
      <QS-common-table
        :data="tableData"
        :columns="headData"
        :pagination="paginationData"
        @change="paginationChange"
      ></QS-common-table>
    </el-form>
  </div>
</template>

<script>
import selectOption from '@/store/dict/selectOptionDict'
// eslint-disable-next-line import/no-cycle
import { getContractList } from '@/api/domain/orders'
import moment from 'moment'
import { parseQueryJsonStr } from '@/utils/querySchema'

export default {
  data() {
    return {
      searchData: {
        deptIdList: [],
        relationReason: '4', // 仅保留订单续约
        plateNo: '', // 车牌号
        customerName: '', // 客户名称
        orderType: '', // 订单类型
        createdDate: '', // 结束时间
      },
      paginationData: { // 分页数据
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
      // 表头
      headData: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '关联记录ID',
            width: 110,
          },
        },
        {
          name: 'relationReason',
          columnProps: {
            prop: 'relationReason',
            label: '关联原因',
            width: 110,
          },
          getText: ({ row }) => selectOption.rderRelatedReason[row.relationReason],
        },
        {
          name: 'orderType',
          columnProps: {
            prop: 'orderType',
            label: '订单类型',
          },
        },
        {
          name: 'oldContractId',
          columnProps: {
            prop: 'oldContractId',
            label: '原订单ID',
          },
          render: ({ row }) => (
            <a
              href="javascript:void(0);"
              onClick={ () => this.pushDetail(row.oldContractId)}
            >
              { row.oldContractId }
            </a>
          ),
        },
        {
          name: 'oldContractPlateNo',
          columnProps: {
            prop: 'oldContractPlateNo',
            label: '原车牌号',
            width: 130,
          },
        },
        {
          name: 'oldContractCustomerName',
          columnProps: {
            prop: 'oldContractCustomerName',
            label: '原合同客户',
            width: 120,
          },
        },
        {
          name: 'newContractId',
          columnProps: {
            prop: 'newContractId',
            label: '新订单ID',
          },
          render: ({ row }) => (
            <a
              href="javascript:void(0)"
              onClick={ () => this.pushDetail(row.newContractId)}
            >
              { row.newContractId }
            </a>
          ),
        },
        {
          name: 'newContractPlateNo',
          columnProps: {
            prop: 'newContractPlateNo',
            label: '新车牌号',
            width: 130,
          },
        },
        {
          name: 'newContractCustomerName',
          columnProps: {
            prop: 'newContractCustomerName',
            label: '新合同客户',
            width: 120,
          },
        },
        {
          name: 'newContractStartDate',
          columnProps: {
            prop: 'newContractStartDate',
            label: '新合同开始日期',
            width: 140,
          },
        },
        {
          name: 'newContractEndDate',
          columnProps: {
            prop: 'newContractEndDate',
            label: '新合同结束日期',
            width: 140,
          },
        },
        {
          name: 'gmtCreate',
          columnProps: {
            prop: 'gmtCreate',
            label: '关联记录创建时间',
            width: 160,
          },
        },
        {
          name: 'deptName',
          columnProps: {
            prop: 'deptName',
            label: '所属部门',
            width: 150,
          },
          showEllipsisTooltip: true,
          limitEllipsisLine: 1,
        },
      ],
      tableData: [], // 表数据
      oLoading: {
        search: false,
      },
    }
  },
  computed: {
    orderTypeList() {
      return this.dictParseList(selectOption.relationOrderTypeList)
    },
  },
  mounted() {
    this.getRouteQuery()
    this.getRelationList()
  },
  methods: {
    getRouteQuery() {
      // 数据报表跳转逻辑
      const queryStr = this.$route.query.query
      if (queryStr) {
        const { search } = parseQueryJsonStr(queryStr)
        const { createdDate } = search
        if (createdDate) this.searchData.createdDate = this.formatDate(createdDate)
      }
    },
    // 解析回显时间
    formatDate(val) {
      const arr = val.split('_')
      const list = []
      if (arr && arr.length) {
        arr.forEach((item) => {
          list.push(moment(Number(item)).format('YYYY-MM-DD HH:mm:ss'))
        })
      }
      return list
    },
    paginationChange(payload) {
      const { pagination } = payload
      this.paginationData.pageNum = pagination.pageNum
      this.paginationData.pageSize = pagination.pageSize
      this.getRelationList()
    },
    // 调转订单详情页
    pushDetail(id) {
      this.$router.push({
        path: '/workbench/rentOrder/detail',
        query: { id },
      })
    },
    // 重置页码搜索
    searchHandle() {
      this.paginationData.pageNum = 1
      this.getRelationList()
    },
    // 获取查询参数
    getSearchParamrs() {
      let startDate = ''
      let endDate = ''
      let relationReason = ''
      if (this.searchData.createdDate?.length) {
        startDate = this.searchData.createdDate?.[0]
        endDate = this.searchData.createdDate?.[1]
      }
      if (this.searchData.relationReason !== '0') {
        relationReason = this.searchData.relationReason
      }
      return { ...this.searchData, startDate, endDate, relationReason }
    },
    // 重制
    formResetFields(form) {
      this.$refs[form].resetFields()
      this.searchHandle()
    },
    getRelationList() {
      this.oLoading.search = true
      const params = {
        ...this.getSearchParamrs(),
        pageNum: this.paginationData.pageNum,
        pageSize: this.paginationData.pageSize,
      }
      getContractList(params).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.tableData = data.items
          this.paginationData.total = data.totalNum
        }
      }).finally(() => {
        this.oLoading.search = false
      })
    },
  },
}
</script>

<style>

</style>
